import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';

import { SnackbarComponent } from './snackbar.component';
import { SnackbarData } from './../../../store/models/snackbar.model';

@Injectable()
export class SnackbarService {
  public isSnackbarOpen = false;
  private snackbarRef: MatSnackBarRef<any>;

  constructor(public snackbar: MatSnackBar) {
  }

  openSnackbar(conf: SnackbarData): MatSnackBarRef<SnackbarComponent> {
    const init = {
      data: {
        message: '',
        button: {},
        type: 'success',
      },
      duration: 1000,
      panelClass: 'success',
    };

    const snackbarConfig = new MatSnackBarConfig();
    snackbarConfig.data = init.data;
    snackbarConfig.duration = init.duration;
    snackbarConfig.horizontalPosition = 'center';
    snackbarConfig.verticalPosition = 'bottom';
    snackbarConfig.panelClass = 'success';

    if (conf.data) {
      snackbarConfig.data = conf.data;
    }

    if (conf.data.type) {
      snackbarConfig.panelClass = conf.data.type;
    }

    if (conf.panelClass) {
      snackbarConfig.panelClass =
        snackbarConfig.panelClass + ' ' + conf.panelClass;
    }

    if (conf.duration) {
      snackbarConfig.duration = conf.duration;
    } else {
      snackbarConfig.duration = 1000;
    }

    if (conf.horizontalPosition) {
      snackbarConfig.horizontalPosition = conf.horizontalPosition;
    }

    if (conf.verticalPosition) {
      snackbarConfig.verticalPosition = conf.verticalPosition;
    }

    this.isSnackbarOpen = true;
    const snackbarRef = this.snackbar.openFromComponent(
      SnackbarComponent,
      snackbarConfig,
    );

    snackbarRef.afterDismissed().subscribe(() => (this.isSnackbarOpen = false));

    this.snackbarRef = snackbarRef;

    return this.snackbarRef;
  }

  close() {
    if (this.snackbarRef) {
      this.snackbarRef.dismiss();
    }
  }
}
